'use strict';

var React = require('react');

/**
 * Create the Internal Authorization Context. Seeds it with a
 *   dummy helper class.
 */
var InternalAuthContext = React.createContext({
  login: function login() {},
  logout: function logout() {},
  isLoggedIn: function isLoggedIn() {
    return false;
  },
  getJwtToken: function getJwtToken() {
    return undefined;
  },
  getJwtInfo: function getJwtInfo() {
    return undefined;
  },
  getUserGroups: function getUserGroups() {
    return [];
  },
  loggedInFetch: function loggedInFetch() {
    throw new Error('Not ready.');
  }
});

exports.InternalAuthContext = InternalAuthContext;
//# sourceMappingURL=internal-auth-context-cu8DDA6h.js.map
